module.exports = __webpack_public_path__ + "static/media/th.fd3b2e9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/th.svg
// module id = 263
// module chunks = 0